; (function ($) {
	var Dialog = function (options, element) {
		this._options = $.extend({}, Dialog.defaults, options);
		this._dialogVisible = false;
		this._hasTemplate = false;
		this._checkpoint = null;
		this._isExecuting = new ExoWeb.Signal();
		this._defaultButton = null;
		this._accelerators = {};

		// If an instance/property was specified, but no buttons, create default buttons
		if (this._options.instance) {
			if (!this._options.buttons) {
				this._options.buttons = [
					{
						label: "Cancel",
						isCancel: true
					},
					{
						label: "Ok",
						autoClose: false,
						click: function () {
							this._checkpoint = null;
							this.close(false);
						}
					}
				]
			}
		} else if (!this._options.buttons) {
			this._options.buttons = {
				"Ok": function () {
					this.close(false);
				}
			}
		}

		if (element) {
			this.$element = $(element);
			this.$element.bind("click", this.open.bind(this, element));
		}

		//this.$element.append(this._create());
		this._dialog = this._create();
		// Ensure dialog has unique ID for focus trap event binding
		if (!this._dialog[0].id) {
			this._dialog[0].id = 'dialog-' + Math.random().toString(36).substr(2, 9);
		}

		// Create and add the dialog UI elements once the DOM is ready
		var that = this;
		var readyDeps = ["ExoWeb.dom"];
		if (this._options.templateDep)
			readyDeps.push(this._options.templateDep);
		Cognito.ready("append-dialog-" + options.title, readyDeps, function ($) {
			that._dialog.appendTo(document.body);

			// Force activation if using templates
			if (that._options.templateName)
				Sys.Application.activateElement(that._dialog[0]);
		});
	};

	Dialog.defaults = {
		title: "",
		width: 400,
		height: 200,
		text: "",
		source: "",
		open: undefined,
		cancel: undefined,
		instance: null,
		property: null,
		templateName: null,
		closeOnEscape: true,
		includeCloseButton: true,
		contentSelector: null,
		closeOnOverlayClick: true,
		modalClass: "",
		contentClass: "",
		onClose: null
	};

	Dialog.activeDialogs = [];

	const zModalOverlay = 1040;

	Dialog.prototype = {
		_create: function () {
			var dialogPane = $("<div class='c-modal scrollbar' />");
			dialogPane.addClass(this._options.modalClass)
								.append("<div class='c-modal-overlay'></div>")
			var dialogContainer = dialogPane;

			dialogContainer.append(this._createContent());

			// Only include the title bar if a title was specified
			if (this._options.title) {
				dialogContainer.prepend(this._createTitle());
			}
			else
				dialogContainer.children().css({ "padding-top": "0px" });

			dialogContainer.append(this._createButtons());

			// Ensure that clicks inside the dialog do not propagate beyond the dialog context
			dialogPane.click(function (event) {
				(event.originalEvent || event).dialog = true;
			});

			return dialogPane;
		},
		_createTitle: function () {
			var titlePane = $("<div class='c-modal-title-bar' />");
			titlePane.append("<div class='c-modal-title'>" + this._options.title + "</div>")

			if (this._options.includeCloseButton) {
				var closePane = $("<button type='button' class='c-modal-close button--no-style' />") // close button
				closePane.append("<i class='icon-remove' />");
				closePane.bind("click", this.close.bind(this));
				titlePane.append(closePane);
			}

			return titlePane;
		},
		_createContent: function () {
			var contentContainer = $("<div class='c-modal-content-container' />");
			var contentPane = $("<div class='c-modal-content' />");
			contentContainer.addClass(this._options.contentClass);
			contentContainer.append(contentPane);
			if (this._options.text) {
				var textContainer = $("<p>");
				if (this._options.text.constructor === String)
					textContainer.html(this._options.text);
				contentPane.append(textContainer);
			} else if (this._options.contentSelector) {
				contentPane.append($(this._options.contentSelector).show());
			}

			// If template name provided, load existing, otherwise create new template
			if (this._options.instance && this._options.templateName)
				contentPane.append(this._loadTemplate());
			else if (this._options.instance)
				contentPane.append(this._createTemplate());

			return contentContainer;
		},
		_createButtons: function () {
			var that = this;
			var buttonPane = $("<div class='c-modal-button-bar' />");
			var leftButtons = $("<div class='c-modal-buttons-left' />");
			var rightButtons = $("<div class='c-modal-buttons-right' />");
			if (this._options.buttons) {
				$.each(this._options.buttons, function (name, props) {
					var button;
					var execute = function () { };
					var autoClose = true;
					var isAlignedRight = true;
					var isAction = false;
					var isDefault = false;
					var isTab = false;
					var isCancel = false;

					// Can use array to pass in additional options
					if (Array.isArray(that._options.buttons)) {
						name = props.label;
						if ($.isFunction(props.click)) execute = props.click;
						if (props.align === "left") isAlignedRight = false;
						autoClose = props.autoClose != false;
						isAction = props.isAction;
						isTab = props.isTab;
						isCancel = props.isCancel;
						isDefault = props.isDefault;
					}
					else {
						if ($.isFunction(props)) {
							execute = props;
						} else {
							if (props.execute && $.isFunction(props.execute)) execute = props.execute;
							isDefault = props.isDefault;
						}
					}

					// Tabbed button
					if (isTab) {
						button = props.isDefaultTab ? $("<a class='c-modal-tab c-modal-tab-active'>" + name + "</a>") : $("<a class='c-modal-tab'>" + name + "</a>");
						isAlignedRight = false;
					}
					else {
						var actionStyle = isAction ? " c-modal-button-action" : "";
						actionStyle += isCancel ? " c-modal-button-cancel button--secondary" : " button--primary";
						button = isAlignedRight ? $("<button type='button' class='c-modal-button button--no-style" + actionStyle + "'>" + name + "</button>") : $("<button type='button' class='c-modal-button c-modal-button-left button--no-style" + actionStyle + "'>" + name + "</button>");
					}
					if (isDefault) that._defaultButton = button;

					var acceleratorChar = null;
					for (var i = 0; i < name.length && !acceleratorChar; i++) {
						if (!that._accelerators[name[i].toLowerCase()]) acceleratorChar = name[i].toLowerCase();
					}

					that._accelerators[acceleratorChar] = button;

					button.bind("click", that._buttonWrapper.bind(that, buttonPane, execute, autoClose, isCancel, button));
					isAlignedRight ? rightButtons.append(button) : leftButtons.append(button);
				});

				buttonPane.append(leftButtons);
				buttonPane.append(rightButtons);
			}

			return buttonPane;
		},
		_createTemplate: function () {
			var templatePane = $("<div class='sys-template' sys:attach='dataview' dataview:data='{~ " + this._options.instance + " }' sys:content-template='form' />");
			templatePane.append("<div sys:attach='content' content:data='{@ " + this._options.property + "}' />");

			return templatePane;
		},
		_loadTemplate: function () {
			return $("<div sys:attach='content' content:data='{~ " + this._options.instance + " }' content:template='" + this._options.templateName + "'></div>");
		},
		_buttonWrapper: function (buttonPane, buttonFunc, autoClose, isCancel, button, event) {
			if (this._isExecuting.isActive()) return;

			if (!isCancel && button.hasClass("c-modal-button"))
				button.addClass("c-modal-button-executing");

			buttonFunc.call(this, event, button);

			var that = this;
			this._isExecuting.waitForAll(function () {
				if (autoClose && that._dialogVisible) that.close(isCancel);
			});
		},
		_bindTo: function (element) {
			if (element) $(element).bind("click", this.open.bind(this));
		},
		_getFocusableElements: function () {
			// Get all focusable elements within the modal
			var focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
			return this._dialog.find(focusableSelectors).filter(':visible').filter(function() {
				return !$(this).is(':disabled');
			});
		},
		_handleFocusTrap: function (e) {
			if (e.keyCode !== 9) return; // Only handle Tab key
			
			var focusableElements = this._getFocusableElements();
			if (focusableElements.length === 0) return;
			
			var firstElement = focusableElements.first();
			var lastElement = focusableElements.last();
			var currentElement = $(e.target);
			
			// Check if current element is within our modal
			if (!this._dialog.find(currentElement).length) {
				// Focus escaped the modal, bring it back to first element
				e.preventDefault();
				firstElement.focus();
				return;
			}
			
			if (e.shiftKey) {
				// Shift+Tab: moving backwards
				if (currentElement.is(firstElement)) {
					e.preventDefault();
					lastElement.focus();
				}
			} else {
				// Tab: moving forward
				if (currentElement.is(lastElement)) {
					e.preventDefault();
					firstElement.focus();
				}
			}
		},
		_createCheckpoint: function () {
			this._checkpoint = context.server.checkpoint();
		},
		open: function (origEvt) {			
			if (this._options.open) {
				if (!this._options.open.call(this, origEvt))

					// Indicate that the dialog was not opened
					return false;
			}

			$('body').addClass('c-modal-active');

			if (this._options.url) {
				this._dialog.find(".c-modal-content").remove();

				var contentContainer = this._dialog.find(".c-modal-content-container");

				this.frame = $("<iframe"
					+ (this._options.name ? " name='" + this._options.name + "'" : "")
					+ " style='width: 100%; height: 100%; overflow-x: hidden; overflow-y: hidden; -ms-overflow-style: scrollbar'"
					+ " src='" + this._options.url + "'"
					+ "></iframe>")
					.appendTo(contentContainer)
					.get(0);
			}
			else if (this._options.text instanceof Function)
				this._dialog.find(".c-modal-content p").html(this._options.text());

			if (origEvt) {
				this.$element = $(origEvt.currentTarget);
				if (origEvt.preventDefault instanceof Function)
					origEvt.preventDefault();
			}

			// Expose the event that caused the dialog to open
			this.event = origEvt;

			if (this._options.checkpoint) {
				window.context.server.beginCapturingChanges();
				this._checkpoint = context.server.checkpoint();
			}

			// Show the overlay and support automatic closure when the overlay is clicked
			if (Cognito.showOverlay && Dialog.activeDialogs.length == 0) {
				Cognito.showOverlay(function () {
					var dialogs = Dialog.activeDialogs;
					Dialog.activeDialogs = [];
					for (var d = dialogs.length - 1; d >= 0; d--) {
						var dialog = dialogs[d];
						if (dialog._options.closeOnOverlayClick)
							dialog.close(true);
					}
				});
			}

			// Set the width and height
			this._dialog.css({
				"max-width": this._options.width + ($.isNumeric(this._options.width) ? "px" : "")
			});

			if (this._dialogVisible)
				return true;

			// Show the dialog
			this._dialog.css("opacity", 1)
									.addClass("is-active")
									.fadeIn();

			// Fade in an overlay above the active dialog, if stacking
			if (Dialog.activeDialogs.length > 0) {
				var dialog = Dialog.activeDialogs[Dialog.activeDialogs.length - 1];
				$(dialog._dialog).css("z-index", zModalOverlay - 1);
				dialog._dialog.find(".c-modal-overlay").fadeIn();
			}

			// Add the dialog to the active dialog stack
			Dialog.activeDialogs.push(this);

			// Bind focus trap for accessibility
			var that = this;
			$(document).on('keydown.focustrap.' + this._dialog[0].id, this._handleFocusTrap.bind(this));

			// Set focus to the first focusable element (the ex button)
			if (this._options.includeCloseButton) {
				setTimeout(function() {
					that._dialog.find(".c-modal-close").focus();
				}, 300); // Small delay to ensure the dialog is fully visible
			} else {
				// Focus first focusable element if no close button
				setTimeout(function() {
					var focusableElements = that._getFocusableElements();
					if (focusableElements.length > 0) {
						focusableElements.first().focus();
					}
				}, 300);
			}

			this._dialogVisible = true;

			// Indicate that the dialog was opened
			return true;
		},
		close: function (isCancel) {

			if (this.frame) {
				var frame = this.frame;

				// Clean up the iframe
				// http://stackoverflow.com/questions/12128458/iframes-and-memory-management-in-javascript
				frame.src = "about:blank";
				setTimeout(function () {
					frame.contentWindow.location.reload();
					setTimeout(function () {
						$(frame).remove();
					}, 1000);
				});

				delete this.frame;
			}

			if ($('.c-modal.is-active, .c-modal[style*="display: block"]').length === 1)
				$('body').removeClass('c-modal-active');

			var that = this;
			if (this._checkpoint && this._options.checkpoint) {
				if (isCancel)
					context.server.rollback(this._checkpoint);
				context.server.stopCapturingChanges();
			}

			if (isCancel && this._options.cancel) {
				this._options.cancel.call(this);
			}

			if (typeof (this._options.onClose) === "function")
				this._options.onClose.call(this);

			$(".c-modal-button:visible").removeClass("c-modal-button-executing");
			// Unbind focus trap events
			$(document).off('keydown.focustrap.' + this._dialog[0].id);
			this._dialog.removeClass("is-active");
			this._dialog.fadeOut(function () { that._isExecuting = new ExoWeb.Signal(); that._dialog.find(".c-modal-overlay").hide() });

			Dialog.activeDialogs.pop(this);

			// Fade out the overlay above the active dialog, if stacking
			if (Dialog.activeDialogs.length > 0) {
				var dialog = Dialog.activeDialogs[Dialog.activeDialogs.length - 1];
				$(dialog._dialog).css("z-index", "");
				dialog._dialog.find(".c-modal-overlay").fadeOut();
			}

			// Hide the overlay, if this is the final dialog
			else
				window.Cognito && Cognito.hideOverlay();

			this._dialogVisible = false;
		},
		pending: function (callback) {
			return this._isExecuting.pending(callback);
		},
		orPending: function (callback) {
			return this._isExecuting.orPending(callback);
		}
	};

	var that = this;

	// For some unknown reason, the event is being bounded multiple times.  To ensure the event is only bounded once, the event is unbind before it is bind.
	$(document)
		.on("keyup.cognito.dialog", function (e) {
			if (Dialog.activeDialogs.length > 0) {
				var dialog = Dialog.activeDialogs[Dialog.activeDialogs.length - 1];

				if (e.altKey || e.ctrlKey)
					return;

				switch (e.keyCode) {
					case 27:
						if (dialog._options.closeOnEscape) {
							dialog.close.call(dialog, true);
							e.preventDefault();
						}
						break;
					default:
						if (!$(e.target).is("input, textarea")) {
							var charCode = e.which || e.keyCode;
							var char = String.fromCharCode(charCode).toLowerCase();
							if (dialog._accelerators[char] && !dialog._accelerators[char].is("[disabled], .disabled"))
								dialog._accelerators[char].trigger("click");
							e.preventDefault();
						}
				}
			}
		})

		// Hide the dialog when the title bar is clicked (so users can peek under the dialog)
		.on("mousedown.cognito.dialog", ".c-modal-title-bar", function (event) {
			if (Dialog.activeDialogs.length > 0 && $(event.srcElement).closest(".c-modal-close").length == 0) {
				var dialog = Dialog.activeDialogs[Dialog.activeDialogs.length - 1];
				$(dialog._dialog).css("opacity", 0.05);
				$(document).on("mousemove.cognito.dialog", function () {
					$(dialog._dialog).css("opacity", 1);
					$(document).off("mousemove.cognito.dialog");
				});
			}
		})

		// Hide the dialog when the title bar is clicked (so users can peek under the dialog)
		.on("click", ".c-modal-overlay", function () {
			if (Dialog.activeDialogs.length > 0) {
				var dialog = Dialog.activeDialogs[Dialog.activeDialogs.length - 1];
				dialog.close(true);
			}
		});

	$.fn.dialog = function (options) {
		try {
			// Determine if the page is hosted in an iframe dialog.
			var frame = window.frameElement;
			if (frame && $(frame.parentElement).is(".c-modal-content-container")) {
				// Determine if the iframe's parent window contains the Cognito jQuery dialog function.
				if (window.parent.$ && window.parent.$.fn && window.parent.$.fn.dialog) {

					// Convert content selectors into text before promoting to parent window
					if (options.contentSelector) {
						options.text = $(options.contentSelector).html();
						options.contentSelector = null;
					}

					// Call the dialog function on the parent window so that all dialogs open in
					// the outermost window, so they don't have to be nested within one another.
					return window.parent.$.fn.dialog(options);
				}
			}
		} catch (e) {
			// Ignore potential cross-domain errors when attempting to access the frame element...
		}

		var dialog = new Dialog(options);

		// Called in the context of a selector
		if (this.length > 0) {
			return this.each(function () {
				var $this = $(this);
				var data = $this.data("cognito.dialog");

				if (!data) $this.data("cognito.dialog", (data = dialog));

				data._bindTo(this);
			});
		}

		// Called in the context of an assignment
		var viewport = $((options.viewport || (options.viewport = document.body)));
		var storage = viewport.data("cognito.dialog");
		if (!storage) viewport.data("cognito.dialog", (storage = []));

		var data = dialog;
		storage.push(data);

		return data;
	};

	$.fn.dialog.constructor = Dialog;
})(jQuery);